module.exports = __webpack_public_path__ + "static/media/npd.294929da.png";